/**
 * Load the page again. A function of its own so a spec can see the reload —
 * jsdom's `window.location.reload` can be neither spied on nor replaced.
 */
export function reloadPage(): void {
  window.location.reload();
}
